import React, { useEffect, useMemo, useState } from 'react';
import { Avatar, Button, Pagination, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

import { publicStreamerApi } from 'src/api';

import './participatingStreamers.scss';

export const ParticipatingStreamers = () => {
  const { t } = useTranslation('public_streamers');
  const [state, setState] = useState({ loading: true, error: false, streamers: [] });
  const [page, setPage] = useState(1);

  useEffect(() => {
    let active = true;

    publicStreamerApi
      .getPublicStreamers()
      .then((response) => {
        if (active)
          setState({ loading: false, error: false, streamers: response?.data?.data || [] });
      })
      .catch(() => {
        if (active) setState({ loading: false, error: true, streamers: [] });
      });

    return () => {
      active = false;
    };
  }, []);

  const pageSize = 10;
  const visibleStreamers = useMemo(
    () => state.streamers.slice((page - 1) * pageSize, page * pageSize),
    [page, state.streamers]
  );

  return (
    <section className="landing__participating-streamers" aria-label={t('title')}>
      <h2 className="landing__participating-streamers-title">{t('title')}</h2>
      <p className="landing__participating-streamers-subtitle">{t('subtitle')}</p>
      {state.error ? (
        <p className="landing__participating-streamers-state">{t('error')}</p>
      ) : null}
      {!state.loading && !state.error && state.streamers.length === 0 ? (
        <p className="landing__participating-streamers-state">{t('empty')}</p>
      ) : null}
      {!state.error && (state.loading || state.streamers.length > 0) ? (
        <>
            <div className="landing__participating-streamers-grid">
              {state.loading
                ? Array.from({ length: 5 }).map((_, index) => (
                    <div className="landing__participating-streamers-streamer-card" key={index}>
                      <Skeleton.Avatar active size={112} shape="circle" />
                      <Skeleton.Input active size="small" />
                    </div>
                  ))
                : visibleStreamers.map((streamer) => (
                    <div
                      className="landing__participating-streamers-streamer-card"
                      key={streamer.twitchUrl}
                    >
                      <Avatar size={112} src={streamer.profileImageUrl || undefined}>
                        {streamer.displayName.slice(0, 1).toUpperCase()}
                      </Avatar>
                      <span>{streamer.displayName}</span>
                      <Button
                        type="primary"
                        size="middle"
                        href={streamer.twitchUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('actions.open_twitch')}
                      </Button>
                    </div>
                  ))}
            </div>
            {!state.loading && state.streamers.length > pageSize ? (
              <Pagination
                className="landing__participating-streamers-pagination"
                current={page}
                pageSize={pageSize}
                total={state.streamers.length}
                showSizeChanger={false}
                onChange={setPage}
              />
            ) : null}
        </>
      ) : null}
    </section>
  );
};
